import React from "react";
type MercadoPagoLogoProps = {
  className?: string;
};
export function MercadoPagoLogo({
  className = "h-5"
}: MercadoPagoLogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/svnwuwJ8abEGFYSig1QkaY/mercado-pago-logo.png" alt="Mercado Pago" className={`w-auto object-contain ${className}`} data-id="element-97" data-mp="111gr2p4675w6" />;
}